import classnames from "classnames";
import { uniqueId } from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import {
  compact as compactNumber,
  formatToDecimals,
  resolveSmallNumbers,
} from "../../utils/number.js";
import CryptoIcon from "../CryptoIcon/CryptoIcon.js";

function Value(props) {
  let {
    value,
    prefix,
    suffix,
    decimals,
    compact,
    compact100k,
    hideIfZero,
    dashIfZero,
    className,
    id,
    small,
    big,
    iconSize,
    ...rest
  } = props;

  value = Number(value);

  if (value === undefined || value === null || (hideIfZero && value === 0)) {
    return "";
  }
  if (value === undefined || value === null || (dashIfZero && value === 0)) {
    return "-";
  }
  let tooltip = null;
  const rawValue = value;

  const showCompactNum = compact100k === true && value >= 100000;
  if (compact === true || showCompactNum) {
    value = compactNumber(value, decimals, true);

    if (!id) {
      id = uniqueId("value_tooltip_");
      tooltip = (
        <UncontrolledTooltip placement="bottom" target={id}>
          {prefix}
          {rawValue}
          {suffix === "%" ? suffix : <span className="ms-1">{suffix}</span>}
        </UncontrolledTooltip>
      );
    }
  } else {
    value = formatToDecimals(value, decimals);
  }

  const { prefix: prefixPrefix, value: newValue } = resolveSmallNumbers(
    rawValue,
    decimals
  );
  if (newValue !== null) {
    value = newValue;
  }

  const IconOrText = (symbol) => {
    if (symbol === "$" || symbol === "%") {
      return symbol;
    } else {
      return (
        <CryptoIcon
          name={symbol}
          className={symbol === prefix ? "me-1" : "ms-1"}
          size={small ? "0.8rem" : big ? "1.5rem" : iconSize}
        />
      );
    }
  };

  return (
    <>
      <span
        id={id}
        className={classnames("d-inline-flex", "align-items-center", className, {
          "text-small": small,
          "lh-sm": small,
          "text-big": big,
        })}
        {...rest}
      >
        {prefixPrefix}
        {prefix ? IconOrText(prefix) : null}
        {value}
        {suffix ? IconOrText(suffix) : null}
      </span>
      {tooltip}
    </>
  );
}

Value.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  prefix: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  suffix: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  decimals: PropTypes.number.isRequired,
  compact: PropTypes.bool.isRequired,
  compact100k: PropTypes.bool.isRequired,
  iconSize: PropTypes.string.isRequired,
  small: PropTypes.bool.isRequired,
  big: PropTypes.bool.isRequired,
};

Value.defaultProps = {
  decimals: 2,
  compact: false,
  compact100k: false,
  iconSize: "1rem",
  small: false,
  big: false,
};
export default Value;
